import versionInfo from '../../../../version.json';

export const environment = {
  production: true,
  version: versionInfo.version,
  hash: '#{git.hash}#',
  envName: '#{environmentName}#',
  redirectUrl: `${window.location.protocol}//${window.location.hostname}${window.location.port === "" ? "" : ":".concat(window.location.port)}/`,
  postLogoutRedirectUrl: `${window.location.protocol}//${window.location.hostname}${window.location.port === "" ? "" : ":".concat(window.location.port)}/`,
  tenantId: '#{tenantId}#',
  clientId: '#{datalab.ui.clientId}#',
  datalabUrl: '#{datalab.api.url}#',
  datalabScope: '#{datalab.api.scope}#',
  fusUrl: '#{fus.url}#',
  fusScope: '#{fus.scope.user}#',
  fusUploadedFor: '#{fus.uploadedFor}#',
  oneFileMaxSizeGb: '#{datalab.upload.file.maxSize}#',
  uploadMaxSizeGb: '#{datalab.upload.maxSize}#',
  requestFileMaxSizeMb: '100', // NOTE: make this configurable
  externalAppLink: '#{datalab.externalAppLink.enabled}#',
  directUpload: '#{datalab.directUpload.enabled}#', // NOTE: direct (script) upload feature flag
  avsEnabled: '#{datalab.avs.enabled}#', // NOTE: AVS integration feature flag
  adlsExplorer: '#{datalab.adlsExplorer.enabled}#' // NOTE: data lake directories explorer feature flag
};
